import { Box } from '@mui/material'
import { GroupByButton } from '@/objects/collection-view/top-bar/GroupByButton.tsx'
import { ColumnsButton } from './ColumnsButton'
import { FilterButton } from './FilterButton'

export function CollectionViewSettingsButtons() {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', ml: 1, mr: 2 }}>
      <GroupByButton />
      <ColumnsButton />
      <FilterButton />
    </Box>
  )
}
